import { supabase } from "@/integrations/supabase/client";

export const getCurrentUserPricingSettings = async (userId?: string | null) => {
  const resolvedUserId = userId || (await supabase.auth.getUser()).data.user?.id;
  if (!resolvedUserId) return null;

  const { data, error } = await supabase
    .from("pricing_settings")
    .select("*")
    .eq("user_id", resolvedUserId)
    .maybeSingle();

  if (error) {
    console.error("Error loading pricing settings:", error);
    return null;
  }

  return data;
};